import { withIcon } from "../Icon"

export const IconPrint = withIcon(
  '<path fill="none" stroke="currentColor" stroke-width="1.5" d="M7.733 17.333H5.6a1.067 1.067 0 0 1-1.067-1.066V12A1.067 1.067 0 0 1 5.6 10.933h12.8A1.067 1.067 0 0 1 19.467 12v4.267a1.067 1.067 0 0 1-1.067 1.066h-2.133m-8.534-6.4V5.6A1.067 1.067 0 0 1 8.8 4.533h6.4A1.066 1.066 0 0 1 16.267 5.6v5.333M7.732 15.2h8.534v4.267H7.732V15.2Z"/>',
)
